module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"changedLanguage":"Idioma alterado com sucesso!"},"en":{"changedLanguage":"Language changed successfully!"},"es":{"changedLanguage":"¡Idioma cambiado con éxito!"},"fr":{"changedLanguage":"Langue changée avec succès!"}}')
  delete Component.options._Ctor
}
